import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { removeAuthenticator } from './Manage2faEndpoints';

export const Manage2faAuthenticatorDisableAppDialog = (props) => {
    const { onClose, open, closeConfigureDialog } = props;

    const handleClose = () => {
        onClose();
    };

    const handleDisable = async () => {
        await removeAuthenticator();
        onClose();
        closeConfigureDialog();
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Disable Authenticator App"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to fully disable your Authenticator App settings?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="primary" onClick={handleClose} autoFocus>Cancel</Button>
                    <Button variant='contained' color="error" onClick={() => handleDisable()}>
                        {'Disable'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}